"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStoreManager = void 0;
const SessionStoreManager = (storeName) => {
    const save = (data) => {
        try {
            global.sessionStorage.setItem(storeName, JSON.stringify(data));
        }
        catch (e) {
            /* eslint-disable no-console */
            console.error(e);
        }
    };
    const load = () => {
        const sessionData = global.sessionStorage.getItem(storeName);
        return sessionData ? JSON.parse(sessionData) : {};
    };
    return { save, load };
};
exports.SessionStoreManager = SessionStoreManager;
//# sourceMappingURL=session-store-manager.js.map